import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
} from "@angular/core";
import { SafeHtml } from "@angular/platform-browser";
import { BvIconRegistry } from "./icon-registry.service";


export type BvIconSize = "sm" | "md" | "lg" | "xl";

/**
 * Icon primitive. Two modes:
 *   - Material Icons font glyph via `name` (the font is loaded globally):
 *       <bv-icon name="groups"></bv-icon>
 *       <bv-icon name="emoji_events" size="xl"></bv-icon>
 *   - Custom SVG via `svgIcon` (registered in BvIconRegistry):
 *       <bv-icon svgIcon="printer"></bv-icon>
 */
@Component({
    selector: "bv-icon",
    template: `@if (svgIcon) {
  <span
    class="bv-icon__svg"
    [innerHTML]="svgContent"
    ></span
    >
  } @else {
    {{ name }}
  }`,
    styleUrls: ["./icon.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: "material-icons bv-icon",
        "[class.bv-icon--svg]": "!!svgIcon",
        "[class.bv-icon--sm]": 'size === "sm"',
        "[class.bv-icon--md]": 'size === "md"',
        "[class.bv-icon--lg]": 'size === "lg"',
        "[class.bv-icon--xl]": 'size === "xl"',
        "aria-hidden": "true",
    },
    imports: []
})
export class BvIconComponent implements OnChanges {
  @Input() name = "";
  @Input() size: BvIconSize = "md";
  @Input() svgIcon?: string;

  svgContent: SafeHtml = "";

  constructor(
    private readonly registry: BvIconRegistry,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnChanges(): void {
    if (this.svgIcon) {
      this.registry.get(this.svgIcon).subscribe((svg) => {
        this.svgContent = svg;
        this.cdr.markForCheck();
      });
    }
  }
}
